import React from 'react'
import useLanguage from 'features/languageReport/useLanguage'
import ReportSubtitleV1 from 'components/Text/ReportSubtitleV1'
import ReportSubtitle from 'components/Text/ReportSubtitle'
import useStyles from 'components/molcules/N1SummaryReport/useStyles'

export default function EEGSummaryBrain3DAPI(props: {
  threeDimensionImage: string
  index: number
  isSummary?: boolean
}) {
  const {threeDimensionImage, index, isSummary} = props
  const classes = useStyles()
  const {textEegAPI} = useLanguage('eeg')

  return (
    <div className={classes.eeg}>
      {isSummary ? (
        <ReportSubtitleV1 number={`${index}`}>
          {textEegAPI?.brain_aging.basic.section.three_dimensional_graph.title}
        </ReportSubtitleV1>
      ) : (
        <ReportSubtitle number={`${index}`}>
          {textEegAPI?.brain_aging.basic.section.three_dimensional_graph.title}
        </ReportSubtitle>
      )}
      <div className={classes.brain3D}>
        <div className='Image-wrapper'>
          <img src={threeDimensionImage} alt='' className='Image' />
        </div>

        <div className='Reference'>
          <div className='Title'>
            {
              textEegAPI?.brain_aging.basic.section.three_dimensional_graph
                .description.main
            }
          </div>
          <div className='Desc'>
            {
              textEegAPI?.brain_aging.basic.section.three_dimensional_graph
                .description.sub[0]
            }
            <br />
            {
              textEegAPI?.brain_aging.basic.section.three_dimensional_graph
                .description.sub[1]
            }
          </div>
        </div>
      </div>
    </div>
  )
}
